var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHsnCodeFinderTool(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4,
    fill: "#E50B20"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.2998 5.00078C3.2998 4.0619 4.06092 3.30078 4.9998 3.30078H10.9998C11.9387 3.30078 12.6998 4.0619 12.6998 5.00078V11.0008C12.6998 11.9397 11.9387 12.7008 10.9998 12.7008H4.9998C4.06092 12.7008 3.2998 11.9397 3.2998 11.0008V5.00078ZM4.9998 4.70078C4.83412 4.70078 4.6998 4.8351 4.6998 5.00078V11.0008C4.6998 11.1665 4.83412 11.3008 4.9998 11.3008H10.9998C11.1655 11.3008 11.2998 11.1665 11.2998 11.0008V5.00078C11.2998 4.8351 11.1655 4.70078 10.9998 4.70078H4.9998Z",
    fill: "#E3B8B8",
    fillOpacity: 0.86
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.2998 17.0008C3.2998 16.0619 4.06092 15.3008 4.9998 15.3008H10.9998C11.9387 15.3008 12.6998 16.0619 12.6998 17.0008V23.0008C12.6998 23.9397 11.9387 24.7008 10.9998 24.7008H4.9998C4.06092 24.7008 3.2998 23.9397 3.2998 23.0008V17.0008ZM4.9998 16.7008C4.83412 16.7008 4.6998 16.8351 4.6998 17.0008V23.0008C4.6998 23.1665 4.83412 23.3008 4.9998 23.3008H10.9998C11.1655 23.3008 11.2998 23.1665 11.2998 23.0008V17.0008C11.2998 16.8351 11.1655 16.7008 10.9998 16.7008H4.9998Z",
    fill: "#E3B8B8",
    fillOpacity: 0.86
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2998 5.00078C15.2998 4.0619 16.0609 3.30078 16.9998 3.30078H22.9998C23.9387 3.30078 24.6998 4.0619 24.6998 5.00078V11.0008C24.6998 11.9397 23.9387 12.7008 22.9998 12.7008H16.9998C16.0609 12.7008 15.2998 11.9397 15.2998 11.0008V5.00078ZM16.9998 4.70078C16.8341 4.70078 16.6998 4.8351 16.6998 5.00078V11.0008C16.6998 11.1665 16.8341 11.3008 16.9998 11.3008H22.9998C23.1655 11.3008 23.2998 11.1665 23.2998 11.0008V5.00078C23.2998 4.8351 23.1655 4.70078 22.9998 4.70078H16.9998Z",
    fill: "#E3B8B8",
    fillOpacity: 0.86
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2998 17.0008C15.2998 16.0619 16.0609 15.3008 16.9998 15.3008H22.9998C23.9387 15.3008 24.6998 16.0619 24.6998 17.0008V23.0008C24.6998 23.9397 23.9387 24.7008 22.9998 24.7008H16.9998C16.0609 24.7008 15.2998 23.9397 15.2998 23.0008V17.0008ZM16.9998 16.7008C16.8341 16.7008 16.6998 16.8351 16.6998 17.0008V23.0008C16.6998 23.1665 16.8341 23.3008 16.9998 23.3008H22.9998C23.1655 23.3008 23.2998 23.1665 23.2998 23.0008V17.0008C23.2998 16.8351 23.1655 16.7008 22.9998 16.7008H16.9998Z",
    fill: "#E3B8B8",
    fillOpacity: 0.86
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9939 31.9652C27.5134 31.9652 31.9878 27.4958 31.9878 21.9826C31.9878 16.4694 27.5134 12 21.9939 12C16.4744 12 12 16.4694 12 21.9826C12 27.4958 16.4744 31.9652 21.9939 31.9652Z",
    stroke: "white",
    strokeWidth: 2.1253,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0635 29.0391L34.8457 34.8147",
    stroke: "white",
    strokeWidth: 2.1253,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHsnCodeFinderTool);
export default __webpack_public_path__ + "static/media/hsn-code-finder-tool.c02e45607cb56d301faef88ae0b74bf6.svg";
export { ForwardRef as ReactComponent };